import api, { dataOf } from './client'

export interface User {
  wechat_bound: boolean
  id: string
  phone: string
  last_login_at: string | null
  total_consumed_points: number
  ppid: string
  username: string
  display_name: string
  status: string
  created_at: string
}
export interface Workspace {
  id: string
  name: string
  kind: string
  purchased_points: number
  subscription_points: number
  reserved_points: number
  outstanding_points: number
  available_points: number
}
export interface Page<T> {
  items: T[]
  total: number
  page: number
  page_size: number
}
export interface Consumption {
  since: string
  points: number
  count: number
  items: Array<{
    id: string
    workspace_id: string
    source_type: string
    source_id: string
    points: number
    created_at: string
  }>
}
export interface Audit {
  outcome: string
  error_message: string
  id: number
  admin: string
  action: string
  target_name: string
  target_id: string
  reason: string
  before: unknown
  after: unknown
  ip: string
  created_at: string
}
export const usersApi = {
  list: (page: number, search: string, status: string, registered = '') =>
    dataOf<Page<User>>(
      api.get('/users', { params: { page, page_size: 20, search, status, registered } }),
    ),
  detail: (id: string) =>
    dataOf<{ user: User; workspaces: Workspace[]; consumption: Consumption }>(
      api.get('/users/' + encodeURIComponent(id)),
    ),
  delete: (id: string, reason: string, confirm_id: string) => dataOf(api.delete('/users/' + encodeURIComponent(id), { data: { reason, confirm_id } })),
  unbindWechat: (id: string, reason: string) => dataOf(api.post('/users/' + encodeURIComponent(id) + '/unbind-wechat', { reason, confirm_id: id })),
  status: (id: string, status: string, reason: string) =>
    dataOf(
      api.patch('/users/' + encodeURIComponent(id) + '/status', {
        status,
        reason,
      }),
    ),
  reset: (id: string, password: string, reason: string) =>
    dataOf(
      api.post('/users/' + encodeURIComponent(id) + '/reset-password', {
        password,
        reason,
      }),
    ),
  recharge: (
    id: string,
    workspace_id: string,
    points: number,
    reason: string,
    key: string,
    confirm_large: boolean,
    credit_kind: 'manual_recharge' | 'team_grant',
  ) =>
    dataOf<{ id: string; available_points: number }>(
      api.post(
        '/users/' + encodeURIComponent(id) + '/recharge',
        { workspace_id, points, reason, confirm_large, credit_kind },
        { headers: { 'Idempotency-Key': key } },
      ),
    ),
  audit: (page: number, filters: Record<string, string>, recharges = false) =>
    dataOf<Page<Audit>>(
      api.get(recharges ? '/recharges' : '/audit-logs', {
        params: { page, page_size: 20, ...filters },
      }),
    ),
}


